<template>
  <v-container fluid class="px-0 py-0">
    <v-layout row nowrap>
      <template v-if="items && items.length > 1">
        <v-flex sm5 md4 lg3 class="pr-3">
          <v-card>
            <v-list dense>
              <v-list-tile append class="group-item" v-for="(c, idx) in items" :key="c" @click="onItemClick(c, idx)">
                <v-list-tile-content>
                  <v-list-tile-title :class="{ 'primary--text': idx == index }">
                    视频{{ idx + 1 }}
                    <v-icon style="display:inline-block;float:right;" v-if="idx == index">chevron_right</v-icon>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex sm7 md8 lg9 class>
          <CcVideoViewer :cfg="{ 'movieUrl': movieUrl }"></CcVideoViewer>
        </v-flex>
      </template>
      <v-flex v-else-if="items && items.length == 1" class="pr-3">
        <CcVideoViewer :cfg="{ 'movieUrl': movieUrl }"></CcVideoViewer>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CcVideoViewer from "@/components/cc-video-viewer.vue";
export default {
  name: "courseware-medias-view",
  components: {
    CcVideoViewer
  },
  props: {
    cfg: Object
  },
  data() {
    return {
      items: [],
      movieUrl: null,
      index: 0
    };
  },
  watch: {
    cfg() {
      this.init();
    }
  },
  methods: {
    init() {
      if (this.cfg != null) {
        this.items = this.cfg.mediaIds;
        if (this.items && this.items.length > 0) {
          this.onItemClick(this.items[0], 0);
        }
      }
    },
    onItemClick(i, idx) {
      let self = this;
      self.index = idx;
      self.$axios.get(`/home/my/media/cc/url/${i}`).then(r => {
        if (r && r.data && r.data.status === "ok") {
          self.movieUrl = r.data.message;
        }
      });
    }
  },
  created() {
    this.init();
  }
};
</script>
